import { Table, Badge, Button } from "react-bootstrap";
import { FaEdit, FaRedo, FaTrash, FaDesktop } from "react-icons/fa"; // Adicionei ícone de desktop para contexto
import classes from "./ApplicationsTable.module.css";

export default function ApplicationsTable({ applications }) {

    const badgeColor = (status) => {
        if (status === "Ativa") return "success";
        if (status === "Expirada") return "danger";
        return "secondary";
    };

    return (
        <div className="table-responsive">
            <Table bordered className={classes.customTable}>
                <thead className="table-dark">
                    <tr>
                        <th>ID</th>
                        <th>Título</th>
                        <th>Tipo</th>
                        <th>Status</th>
                        <th>Criado em</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {applications.map((l, index) => {
                        const rowStyle = index % 2 === 0 ? classes.rowEven : classes.rowOdd;

                        return (
                            <tr key={l.id} className={rowStyle}>
                                <td>{l.id}</td>
                                <td className="text-nowrap">{l.app}</td>

                                <td>{l.type}</td>
                                <td>{l.status}</td>
                                <td className="text-nowrap">{l.expiration}</td>
                                <td>
                                    <div className="d-flex justify-content-center">
                                        <Button size="sm" variant="outline-primary" className="me-1 mr-1" title="Editar">
                                            <FaEdit />
                                        </Button>
                                        <Button size="sm" variant="outline-success" className="me-1 mr-1" title="Renovar">
                                            <FaRedo />
                                        </Button>
                                        <Button size="sm" variant="outline-danger" title="Excluir">
                                            <FaTrash />
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
}